export const boomcoPartnership230309 = {
  en: {
    subject: "[Partnership] NEOPIN signs partnership agreement with Boomco",
    body: `NEOPIN has signed a partnership agreement with Boomco Communications, a blockchain education platform, to expand the ecosystem of the L2E (Learn to Earn) platform.

    Through the wallet connection, Boomco will be onboarded to NEOPIN, and the DeFi products for Boomco's governance token 'BOOM' will also be released on NEOPIN. As Boomco's target strategy for Southeast Asia is in line with the major P2E game users on NEOPIN, NEOPIN and Boomco will cooperate in global joint marketing to build synergy between global P2E-L2E services.
    `,
  },
};
